import { useMemo } from 'react';
import { type User } from 'oidc-client-ts';

import { type UserProfile } from '#packages/data-collection/models/user-profile';
import { isNil } from '#packages/data-collection/libs/lodash';

export const useUserProfile = (user?: User | null) => {
  const profile = useMemo<UserProfile | undefined>(() => {
    if (isNil(user)) {
      return undefined;
    }

    const fullName =
      `${user.profile.given_name} ${user.profile.family_name}`.trim();

    const avatarText = [user.profile.given_name, user.profile.family_name]
      .map((namePart) => namePart?.charAt(0).toUpperCase() ?? '')
      .join('')
      .trim();

    return {
      firstName: user.profile.given_name ?? '',
      lastName: user.profile.family_name ?? '',
      fullName: fullName,

      avatarText,
      email: user.profile.email ?? '',
    };
  }, [user]);

  return profile;
};
